import Trans from 'next-translate/Trans'
import GHref from 'tennders-market/common/components/element/GHref'

export const DealClose = () => (
  <div
    className="tennders-under-neg-confirm-congrats bg-color-s p-16 br-6"
    style={{ display: 'none' }}
  >
    <div className="mb-10 bold"><Trans i18nKey="offer:congratulations" /></div>
    <div className="mb-10">
      <Trans i18nKey="offer:madeDeal" />
      <strong>
        Lamaignere Cargo
        for
        850€
      </strong>
    </div>
    <div className="text-12 lh-1-3">
      <Trans i18nKey="offer:nextStep" />
      <GHref className="text-underline"><Trans i18nKey="offer:generateConfirmationDoc" /></GHref>
    </div>
  </div>
)
